import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingTaxCodes: false,
  loadingTaxCode: false,
  loadingTaxCodeCreate: false,
  loadingTaxCodeUpdate: false,
  loadingTaxCodeDelete: false,

  errorLoadingTaxCodes: null,
  errorLoadingTaxCode: null,
  errorCreatingTaxCode: null,
  errorUpdatingTaxCode: null,
  errorDeletingTaxCode: null,

  taxCodes: [],
  taxCode: null,

  serverStatus: null,
};

export const taxCodeSlice = createSlice({
  name: "taxCode",
  initialState,
  reducers: {
    setLoadingTaxCodes(state) {
      state.loadingTaxCodes = true;
      state.errorLoadingTaxCodes = null;
    },
    setLoadingTaxCode(state) {
      state.loadingTaxCode = true;
      state.errorLoadingTaxCode = null;
    },
    setLoadingTaxCodeCreate(state) {
      state.loadingTaxCodeCreate = true;
      state.errorCreatingTaxCode = null;
    },
    setLoadingTaxCodeUpdate(state) {
      state.loadingTaxCodeUpdate = true;
      state.errorUpdatingTaxCode = null;
    },
    setLoadingTaxCodeDelete(state) {
      state.loadingTaxCodeDelete = true;
      state.errorDeletingTaxCode = null;
    },

    setErrorLoadingTaxCodes(state, { payload }) {
      state.loadingTaxCodes = false;
      state.errorLoadingTaxCodes = payload;
    },
    setErrorLoadingTaxCode(state, { payload }) {
      state.loadingTaxCode = false;
      state.errorLoadingTaxCode = payload;
    },
    setErrorCreatingTaxCode(state, { payload }) {
      state.loadingTaxCodeCreate = false;
      state.errorCreatingTaxCode = payload;
    },
    setErrorUpdatingTaxCode(state, { payload }) {
      state.loadingTaxCodeUpdate = false;
      state.errorUpdatingTaxCode = payload;
    },
    setErrorDeletingTaxCode(state, { payload }) {
      state.loadingTaxCodeDelete = false;
      state.errorDeletingTaxCode = payload;
    },

    setTaxCodes(state, { payload }) {
      state.loadingTaxCodes = false;
      state.errorLoadingTaxCodes = null;
      state.taxCodes = payload;
    },

    setTaxCode(state, { payload }) {
      state.loadingTaxCode = false;
      state.errorLoadingTaxCode = null;
      state.taxCode = payload;
    },

    createTaxCodeSuccess(state, { payload }) {
      state.taxCodes = [payload, ...state.taxCodes];
      state.loadingTaxCodeCreate = false;
      state.errorCreatingTaxCode = null;
    },

    updateTaxCodeSuccess(state, { payload }) {
      state.taxCodes = state.taxCodes.map((u) =>
        u.id === payload.id ? payload : u,
      );

      if (state.taxCode && state.taxCode.id === payload.id) {
        state.taxCode = payload;
      }

      state.loadingTaxCodeUpdate = false;
      state.errorUpdatingTaxCode = null;
    },

    deleteTaxCodeSuccess(state, { payload: idToDelete }) {
      state.taxCodes = state.taxCodes.filter((u) => u.id !== idToDelete);

      if (state.taxCode && state.taxCode.id === idToDelete) {
        state.taxCode = null;
      }

      state.loadingTaxCodeDelete = false;
      state.errorDeletingTaxCode = null;
    },

    setServerResponseStatus(state, { payload }) {
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingTaxCodes,
  setLoadingTaxCode,
  setLoadingTaxCodeInfo,
  setLoadingTaxCodeCreate,
  setLoadingTaxCodeUpdate,
  setLoadingTaxCodeDelete,

  setErrorLoadingTaxCodes,
  setErrorLoadingTaxCode,
  setErrorLoadingTaxCodeInfo,
  setErrorCreatingTaxCode,
  setErrorUpdatingTaxCode,
  setErrorDeletingTaxCode,

  setTaxCodes,
  setTaxCode,
  createTaxCodeSuccess,
  updateTaxCodeSuccess,
  deleteTaxCodeSuccess,

  setServerResponseStatus,
} = taxCodeSlice.actions;

export default taxCodeSlice.reducer;

export const selectTaxCode = (state) => state.taxCode;
